<div class="clients-content">
    <div class="row rsponsive_contact">
        <div class="col-md-6">
            <h3 class="main-heading">Write to us!</h3>
            <p class="desc">Wherever and whenever, Ehmulation will create and execute at lightning speed.</p>
        </div>
        <div class="col-md-6">
            <form action="" class="needs-validation" novalidate>
                <div class="form-group">
                    <input type="text" id="fname" name="fname" required placeholder="Your Name">

                </div>
                <input type="text" id="fname" name="fname" placeholder="Your Email">
                <input type="text" id="fname" name="fname" placeholder="Your Contact">
                <input type="text" id="fname" name="fname" placeholder="Your Message">
                <div class="text-center message mt-5">
                    <a href="#"> Send Message</a>
                </div>
            </form>
        </div>
    </div>
    <div class="row justify-content-center copy_right">
        <p>© 2021 Copyright: Ehmulation</p>
    </div>
</div>